import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  environment: 'preprod',
  instanceId: '',
  selectedTools: '*', // * means all tools
  timeout: 30000,
};

export default defaults;
